import { createSlice } from '@reduxjs/toolkit';

const notifications = createSlice({
	name: 'notifications',
	initialState: {
		success: null,
		warning: null,
		error: null,
	},
	reducers: {
		addSuccessNotification: (state, action) => {
			state.error = null;
			state.warning = null;
			state.success = {
				title: action.payload.title,
				content: action.payload.content,
				color: 'primary',
				icon: 'check',
				progress: 100,
				hideDelay: 3500,
				visible: true,
			};
		},
		addWarningNotification: (state, action) => {
			state.error = null;
			state.success = null;
			state.warning = {
				title: action.payload.title,
				content: action.payload.content,
				color: 'warning',
				icon: 'exclamation-triangle',
				progress: 100,
				hideDelay: 3500,
				visible: true,
			};
		},
		addErrorNotification: (state, action) => {
			state.success = null;
			state.warning = null;
			state.error = {
				title: action.payload.title,
				content: action.payload.content,
				color: 'danger',
				icon: 'times',
				progress: 100,
				hideDelay: 3500,
				visible: true,
			};
		},
	},
});

export default notifications.reducer;
export const {
	addSuccessNotification,
	addWarningNotification,
	addErrorNotification,
} = notifications.actions;
